<template>
  <div class="home">
    <div class="title">
      <span class="basics-price">基础金价：{{basicsPrice}}元/g</span>
      <span class="basics-price">基础银价：{{silverPrice}}元/g</span>
      <span class="basics-price">金条价格：{{costPrice}}元/g</span>
      <span class="basics-price">自定义金价：{{customGold}}元/g</span>
      <span class="basics-price">自定义银价：{{customSilver}}元/g</span>
      <span class="basics-price">自定义金条价格：{{customCost}}元/g</span>


      <Input v-model="commodity" @on-search="search" search enter-button="搜索" placeholder="请输入商品名称..." style="width:300px; float: right; margin-left:5px;"/>
      <Select v-model="category" style="width:200px; float: right" placeholder="请选择分类..." @on-change="categoryChange" clearable >
        <Option v-for="item in categoryLists" :value="item.category_id" :key="item.category_id">{{ item.name }}</Option>
      </Select>
    </div>
    <Table :columns="columns" :data="list" ref="selection" @on-selection-change="selectChange">
      <template slot-scope="{ row }" slot="img">
        <img :src="row.image[0].file_path" style="width:40px; height:40px;">
      </template>

      <template slot-scope="{ row, index }" slot="price">
        <Input
          v-for="item in row.sku"
          :key="`edit-${item.goods_sku_id}`"
          type="text"
          v-model="editPrice"
          v-if="editIndex === index"
        />
        <div v-for="item in row.sku" :key="`view-${item.goods_sku_id}`" v-else>{{item.goods_price}}</div>
      </template>

      <template slot-scope="{ row }" slot="change-price">
        <span v-for="item in row.sku" :key="item.goods_sku_id">{{item.change_goods_price}}</span>
      </template>

      <template slot-scope="{ row, index }" slot="line-price">
        <Input
          v-for="item in row.sku"
          :key="`edit-${item.goods_sku_id}`"
          type="text"
          v-model="editLinePrice"
          v-if="editIndex === index"
        />
        <div v-for="item in row.sku" :key="`view-${item.goods_sku_id}`" v-else>{{item.line_price}}</div>
      </template>

      <template slot-scope="{ row }" slot="change-line-price">
        <span v-for="item in row.sku" :key="item.goods_sku_id">{{item.change_line_price}}</span>
      </template>

      <template slot-scope="{ row }" slot="weight">
        <div v-for="item in row.sku">{{(item.goods_weight).toFixed(2)}}</div>
      </template>

      <template slot-scope="{ row }" slot="silver">
        <div v-for="item in row.sku">{{item.goods_silver_weight ? (item.goods_silver_weight).toFixed(2) : '--'}}</div>
      </template>

      <template slot-scope="{ row, index }" slot="action">
        <div v-if="editIndex === index">
          <Button @click="handleSave(index)" style="margin-right:5px">保存</Button>
          <Button @click="editIndex = -1">取消</Button>
        </div>
        <div v-else>
          <Button @click="handleEdit(row, index)">操作</Button>
        </div>
      </template>
    </Table>

    <div class="page">
      <Page :total="total" :page-size="30" @on-change="changePage"/>
    </div>

    <div class="button">
      <Button @click="handleSelectAll(true)" style="margin-right: 5px;">设置全选</Button>
      <Button @click="handleSelectAll(false)">取消全选</Button>
      <Button @click="updatePriceOnline" type="primary" style="float: right">更新</Button>
      <Button @click="updatePrice" style="float: right; margin-right:5px;">批量更新价格</Button>
      <Select
        v-model="TemModel"
        style="width:200px; margin-right: 5px; float: right"
        placeholder="请选择价格模板"
      >
        <Option
          v-for="item in TemplateList"
          :value="item.formula"
          :key="item.goods_price_template_id"
        >{{ item.name }}</Option>
      </Select>
    </div>
  </div>
</template>

<script>
import { Button, Table, Select, Option, Page, Input } from "iview";
import Expand from "@/components/expand.vue";
import { getList, updateList, categoryList } from "@/api/listReq";
import { getPrice } from "@/api/goldPrice";
import { getTemplate, getParameter } from "@/api/templateReq";
export default {
  name: "home",

  components: {
    Button,
    Table,
    Select,
    Option,
    Page,
    Input,
    Expand
  },

  data() {
    return {
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "商品Id",
          key: "goods_id"
        },
        {
          title: "商品图片",
          slot: "img"
        },
        {
          title: "商品名称",
          key: "goods_name",
          align: "center"
        },
        {
          title: "价格",
          align: "center",
          children: [
            {
              title: "原始价格",
              slot: "price",
              align: "center"
            },
            {
              title: "更改后价格",
              slot: "change-price",
              align: "center"
            }
          ]
        },
        {
          title: "划线价格",
          align: "center",
          children: [
            {
              title: "原始价格",
              slot: "line-price",
              align: "center"
            },
            {
              title: "更改后价格",
              slot: "change-line-price",
              align: "center"
            },
            {
              type: "expand",
              width: 20,
              render: (h, params) => {
                return h(Expand, {
                  props: {
                    row: params.row,
                    index: params.index
                  },
                  on: {
                    clickPrice: arr => {
                      this.handleOneChange(arr);
                    },
                    clickModelPrice: arr => {
                      this.handleModelOneChange(arr);
                    },
                    clickLinePrice: arr => {
                      this.handleOneLineChange(arr);
                    },
                    clickModelLinePrice: arr => {
                      this.handleModelOneLineChange(arr);
                    }
                  }
                });
              }
            }
          ]
        },
        {
          title: "克重(克)",
          slot: "weight",
          align: "center",
          width: 150
        },
        {
          title: "银重(克)",
          slot: 'silver',
          align: "center"
        }
      ],
      list: [],
      page: 1,
      total: null,
      TemplateList: [],
      TemModel: "",
      selectionList: [],
      disposedList: [],
      basicsPrice: "",
      editIndex: -1, // 当前聚焦的输入框的行数
      editPrice: "",
      editLinePrice: "",
      commodity: '',
      category: '',
      categoryLists: [],
      //银价
      silverPrice: '',
      // 金条价格
      costPrice: '',
      // 自定义金价
      customGold: '',
      // 自定义银价
      customSilver: '',
      // 自定义金条价格
      customCost: '',
    };
  },

  mounted() {
    this.getGoodsList({page: this.page});
    categoryList().then(res=>{
      this.categoryLists = res.data.msg.list.all
    })
  },

  activated() {
    getTemplate().then(res => {
      this.TemplateList = res.data.data;
    });

    getPrice('JO_9754').then(res => {
      
      this.silverPrice = (res.data.data['JO_9754'].q63 / 1000).toFixed(2); 
      this.basicsPrice = res.data.data.base_price;
      this.costPrice = res.data.data.perfect_gold.cost;

    });

    getParameter().then(res=>{
      console.log('getParameter',res)
      if(res.data.data.length!==0){
         res.data.data.forEach(element => {
          if(element.key==='z'){
            this.customGold = element.value;
          }
          if(element.key==='w'){
            this.customSilver = element.value;
          }
          if(element.key==='c'){
            this.customCost = element.value;
          }
        });
      }
    })

  },

  methods: {
    getGoodsList({page, search, category_id}) {
      getList({page, search, category_id}).then(res => {
        this.list = res.data.data.lists;
        //增加改价后数据，进行对比
        this.list.forEach(ele => {
          ele.sku.forEach(element => {
            this.$set(element, "change_goods_price", "--");
            this.$set(element, "change_line_price", "--");
          });
        });
        this.total = res.data.data.count;
        this.page = res.data.data.page;
        this.selectionList = []
      });
    },

    handleSelectAll(status) {
      this.$refs.selection.selectAll(status);
    },

    changePage(page) {
      this.getGoodsList({page});
      this.disposedList = []
    },

    selectChange(selection) {
      this.selectionList = selection;
    },

    updatePrice() {
      if (!this.TemModel) {
        this.$Message.error("请选择价格模板");
        return;
      }
      try {
        // 校验价格模板是否正常
        var x = this.basicsPrice;
        var y = Number(this.silverPrice);
        var z = Number(this.customGold)
        var w = Number(this.customSilver);
        var b = Number(this.costPrice);
        var c = Number(this.customCost || 0);
        var s1 = 0
        var s2 = 0
        eval(this.TemModel);
      } catch (exception) {
        this.$Message.error("价格模板不正确!");
        return;
      }
      if (this.selectionList.length === 0) {
        this.$Message.error("请选择商品!");
        return;
      }

      this.$Modal.confirm({
        title: `是否已(${this.TemModel})为价格模板？`,
        onOk: () => {
          this.disposeList();
        }
      });
    },

    disposeList() {
      //按照接口生成数组
      this.selectionList.forEach(element => {
        element.sku.forEach(ele => {
          this.disposedList.push({
            goods_sku_id: ele.goods_sku_id,
            goods_price: ele.goods_price,
            line_price: ele.line_price,
            goods_weight: ele.goods_weight,
            goods_silver_weight: ele.goods_silver_weight,
            goods_sell_wage: ele.goods_sell_wage
          });
        });
      });

      this.disposedList = this.disposedList.map(ele => {
        // 基础价格乘以商品重量
        const x = (Number(this.basicsPrice || 0) * Number(ele.goods_weight || 0));
        // 银价乘以商品银重量
        const y = (Number(this.silverPrice || 0) * Number(ele.goods_silver_weight || 0));
        // 自定义金价乘以商品重量
        const z = (Number(this.customGold || 0) * Number(ele.goods_weight || 0));
        // 自定义银价乘以商品银重量
        const w = (Number(this.customSilver || 0 ) * Number(ele.goods_silver_weight || 0));
        // 成本价乘以商品重量
        const b = (Number(this.costPrice || 0) * Number(ele.goods_weight || 0));
        // 自定义成本乘以商品重量
        const c = (Number(this.customCost || 0) * Number(ele.goods_weight || 0));
        // 商品销售工资乘以商品重量
        const s1 = Number(ele.goods_sell_wage || 0) * Number(ele.goods_weight || 0);
        // 商品销售工资乘以商品银重量
        const s2 = Number(ele.goods_sell_wage || 0) * Number(ele.goods_silver_weight || 0);
        
   
        
        if(this.TemModel.indexOf('|')>-1){
          //  有公式
          if (Number(ele.line_price)) {
            var ratio = ele.line_price / ele.goods_price;
          }
          
          let temArr = this.TemModel.split("|");
          
          try {
            // 足金和金条用同一条公式，参数改成金条
            const calculateGold = new Function('b','c', 'x', 'y', 'z', 'w', 's1', 's2', `return ${temArr[0]}`);
            // 银饰用另一条公式
            const calculateSilver = new Function('x', 'y', 'z', 'w', 's1', 's2', `return ${temArr[1]}`);
            let gold = calculateGold(b, c, x, y, z, w, s1, s2);
            let silver = calculateSilver(x, y, z, w, s1, s2);
            
            if (isNaN(gold)) gold = 0;
            if (isNaN(silver)) silver = 0;
            
            
            ele.goods_price = (gold + silver).toFixed(2);
          } catch (error) {
            ele.goods_price = '0.00';
          }
          
        } else {
          // 只有一个公式
          if (Number(ele.line_price)) {
            var ratio = ele.line_price / ele.goods_price;
          }
          
          try {
            const calculate = new Function('x', 'y', 'z', 'w', 's1', 's2', `return ${this.TemModel}`);
            const calculatedPrice = calculate(x, y, z, w, s1, s2);
            
            if (isNaN(calculatedPrice)) {
              ele.goods_price = '0.00';
            } else {
              ele.goods_price = calculatedPrice.toFixed(2);
            }
          } catch (error) {
            ele.goods_price = '0.00';
          }
        }
        
        if (Number(ele.line_price)) {
          ele.line_price = (ratio * Number(ele.goods_price)).toFixed(2);
        }
        
        return ele;
      });

      this.list.forEach(ele => {
        ele.sku.forEach(element => {
          this.disposedList.forEach(option => {
            if (option.goods_sku_id == element.goods_sku_id) {
              element.change_goods_price = option.goods_price;
            }
          });
        });
      });
    },

    handleSave() {},

    handleEdit(row, index) {
      this.editIndex = index;
    },

    handleOneChange(arr) {
      let isInclide = this.disposedList.some(ele => {
        return ele.goods_sku_id === arr[0];
      });
      if (isInclide) {
        this.disposedList.forEach(ele => {
          if (ele.goods_sku_id === arr[0]) {
            ele.goods_price = arr[2];
            this.list[arr[1]].sku[0].change_goods_price = arr[2];
          }
        });
      } else {
        this.disposedList.push({
          goods_sku_id: this.list[arr[1]].sku[0].goods_sku_id,
          goods_price: arr[2],
          line_price: this.list[arr[1]].sku[0].line_price,
          goods_weight: this.list[arr[1]].sku[0].goods_weight,
          goods_sell_wage: this.list[arr[1]].sku[0].goods_sell_wage
        });
        this.list[arr[1]].sku[0].change_goods_price = arr[2];
      }
    },

    handleModelOneChange(arr) {
      let isInclide = this.disposedList.some(ele => {
        return ele.goods_sku_id === arr[0];
      });
      if (isInclide) {
        this.disposedList.forEach(ele => {
          if (ele.goods_sku_id === arr[0]) {
            ele.goods_price = arr[2];
            this.list[arr[1]].sku[arr[3]].change_goods_price = arr[2];
          }
        });
      } else {
        this.disposedList.push({
          goods_sku_id: this.list[arr[1]].sku[arr[3]].goods_sku_id,
          goods_price: arr[2],
          line_price: this.list[arr[1]].sku[arr[3]].line_price,
          goods_weight: this.list[arr[1]].sku[arr[3]].goods_weight,
          goods_sell_wage: this.list[arr[1]].sku[arr[3]].goods_sell_wage
        });
        this.list[arr[1]].sku[arr[3]].change_goods_price = arr[2];
      }
    },

    handleOneLineChange(arr) {
      let isInclide = this.disposedList.some(ele => {
        return ele.goods_sku_id === arr[0];
      });
      if (isInclide) {
        this.disposedList.forEach(ele => {
          if (ele.goods_sku_id === arr[0]) {
            ele.line_price = arr[2];
            this.list[arr[1]].sku[0].change_line_price = arr[2];
          }
        });
      } else {
        this.disposedList.push({
          goods_sku_id: this.list[arr[1]].sku[0].goods_sku_id,
          goods_price: this.list[arr[1]].sku[0].goods_price,
          line_price: arr[2],
          goods_weight: this.list[arr[1]].sku[0].goods_weight,
          goods_sell_wage: this.list[arr[1]].sku[0].goods_sell_wage
        });
        this.list[arr[1]].sku[0].change_line_price = arr[2];
      }
    },

    handleModelOneLineChange(arr) {
      let isInclide = this.disposedList.some(ele => {
        return ele.goods_sku_id === arr[0];
      });
      if (isInclide) {
        this.disposedList.forEach(ele => {
          if (ele.goods_sku_id === arr[0]) {
            ele.line_price = arr[2];
            this.list[arr[1]].sku[arr[3]].change_line_price = arr[2];
          }
        });
      } else {
        this.disposedList.push({
          goods_sku_id: this.list[arr[1]].sku[arr[3]].goods_sku_id,
          goods_price: this.list[arr[1]].sku[arr[3]].goods_price,
          line_price: arr[2],
          goods_weight: this.list[arr[1]].sku[arr[3]].goods_weight,
          goods_sell_wage: this.list[arr[1]].sku[arr[3]].goods_sell_wage
        });
        this.list[arr[1]].sku[arr[3]].change_line_price = arr[2];
      }
    },

    updatePriceOnline() {
      updateList(this.disposedList).then(res => {
        this.$Message.success("修改成功");
        this.getGoodsList({page: this.page});
      });
    },

    search() {
      if(!this.commodity) {
        this.$Message.error("请输入搜索内容!");
        return
      }
      this.list = [];
      this.disposedList = [];
      this.page = 1;
      this.getGoodsList({page: this.page, search: this.commodity})
    },

    categoryChange(value) {
      this.list = [];
      this.disposedList = [];
      this.page = 1;
      this.getGoodsList({page: this.page, category_id: value})
    }
  }
};
</script>

<style lang="less">
.home {
  padding: 10px 20px;
  .title{
    height: 40px;
    .basics-price{
      margin-right: 10px;
    }
  }
  .page {
    margin-top: 10px;
    text-align: right;
  }
  .button {
    margin-top: 10px;
  }
}
</style>
